export type TipoDeEnvioDeEmail = 'NOTA_DA_VENDA' | 'VALE_PRESENTE'

export type StatusDeEnvioDeEmail = 'ENVIADO' | 'FALHOU'

export const tiposDeEnvioDeEmail: { text: string; value: TipoDeEnvioDeEmail }[] = [
	{ text: 'Nota da venda', value: 'NOTA_DA_VENDA' },
	{ text: 'Vale-presente', value: 'VALE_PRESENTE' },
]

export const statusDeEnvioDeEmail: { text: string; value: StatusDeEnvioDeEmail }[] = [
	{ text: 'Enviado', value: 'ENVIADO' },
	{ text: 'Falhou', value: 'FALHOU' },
]

export interface IntegracaoDeEmailDaLoja {
	lojaId: string
	emailDeEnvio: string | null
	nomeDoRemetente: string | null
	possuiChaveApi: boolean
	chaveApiMascarada: string | null
	envioAtivo: boolean
	enviarXmlJuntoComPdf: boolean
	testeAprovado: boolean
	testeAprovadoEm: string | null
}

export interface DadosDaIntegracaoDeEmail {
	emailDeEnvio: string
	nomeDoRemetente: string | null
	chaveApi: string | null
	envioAtivo: boolean
	enviarXmlJuntoComPdf: boolean
}

export interface EnvioDeEmail {
	id: string
	dataHora: string
	lojaId: string
	vendaId: string
	identificadorDaVenda: string | null
	tipo: TipoDeEnvioDeEmail
	tipoDescricao: string
	destinatario: string
	status: StatusDeEnvioDeEmail
	statusDescricao: string
	motivoDaFalha: string | null
	codigoDoEnvio: string | null
	tentativas: number | null
}
